// Базовые секции
const BASE_WHY_PERFECT = {
    title: 'Видеопоздравление от ИИ-звезды',
    titleHighlight: 'идеально подходит,',
    reasons: [
        'Хочешь оригинально поздравить, но не знаешь как?',
        'Живые звезды стоят очень дорого и не отвечают в ЛС?',
        'У тебя мало времени, нужно срочно поздравить и произвести вау-эффект?'
    ]
};

const BASE_FIVE_REASONS = [
    {title: 'Эмоции бесценны', text: 'А видео с озвучкой стоит всего 890 руб.'},
    {title: 'Время не ждет', text: 'Получи готовое видео за 5 минут'},
    {title: 'Вау-эффект', text: 'Ваше видео будут пересылать друзьям'},
    {title: 'Звезды с неба падают', text: 'Выбери звезду на свой вкус от Путина до Маска'},
    {title: '100% гарантия возврата', text: 'Вернем деньги, если ИИ-звезда начудит...'}
];

const BASE_OCCASIONS = [
    {id: 'birthday', name: 'День рождения', icon: '🎂'},
    {id: 'jubilee', name: 'Юбилей', icon: '🎊'},
    {id: 'wedding', name: 'Свадьба', icon: '💍'},
    {id: 'promotion', name: 'Повышение', icon: '🚀'},
    {id: 'graduation', name: 'Выпускной', icon: '🎓'},
    {id: 'retirement', name: 'Выход на пенсию', icon: '🏖️'},
    {id: 'anniversary', name: 'Годовщина', icon: '💑'},
    {id: 'custom', name: 'Своё', icon: '💬'}
];

// Конфиг главной страницы
const HOME_CONFIG = {
    // Синхронизировано с index.html и scripts/prerender.js (homeMeta):
    // App.jsx пишет эти строки в document.title/description при гидрации,
    // и короткий вариант здесь затирал SEO-тайтл из пререндера.
    title: 'Создать видеопоздравление от ИИ-звезды за 5 минут с озвучкой',
    description: 'Создайте видеопоздравление от ИИ-звезды за 5 минут. Сгенерируйте поздравление с днем рождения с озвучкой и готовым видео онлайн. Быстро и эффектно.',
    hero: {
        title: 'Создай видеопоздравление',
        titleHighlight: 'от ИИ-звезды',
        features: ['890 руб. видео с озвучкой', 'готовое видео за 3 минуты']
    },
    occasions: BASE_OCCASIONS,
    whyPerfect: BASE_WHY_PERFECT,
    fiveReasons: BASE_FIVE_REASONS,
};

// Конфиг раздела звонков (/zvonki) — тот же макет лендинга, свой копирайт.
export const ZVONKI_CONFIG = {
    title: 'Звонок от ИИ-звезды в нужное время — 390 ₽ | Selebrus',
    description: 'Закажите телефонный звонок голосом звезды: выберите звезду, текст и время — мы позвоним и поздравим лично. Послушайте превью бесплатно. 390 ₽ за звонок.',
    keywords: 'звонок от звезды, звонок голосом звезды, заказать звонок от знаменитости, звонок поздравление по телефону',
    hero: {
        title: 'Закажи звонок',
        titleHighlight: 'от ИИ-звезды',
        features: ['390 руб. за звонок', 'позвоним точно в нужное время']
    },
    occasions: BASE_OCCASIONS,
    whyPerfect: {
        title: 'Звонок от ИИ-звезды',
        titleHighlight: 'идеально подходит,',
        reasons: [
            'Хочешь удивить так, чтобы об этом рассказывали друзьям?',
            'Живые звезды не берут трубку и стоят как машина?',
            'Нужно поздравить точно в момент — в полночь или к началу застолья?'
        ]
    },
    fiveReasons: [
        {title: 'Вау-эффект по телефону', text: 'Звонок от звезды — всего 390 руб.'},
        {title: 'Точно вовремя', text: 'Выберите дату и время — позвоним минута в минуту'},
        {title: 'Сначала послушайте', text: 'Бесплатное аудиопревью до оплаты'},
        {title: 'Звезды с неба падают', text: 'Выбери звезду на свой вкус от Путина до Маска'},
        {title: '100% гарантия возврата', text: 'Не дозвонились — вернём кредит автоматически'}
    ],
};

export function getPageConfig() {
    return HOME_CONFIG;
}
